<template>
  <template v-if="gridModeEnabled">
    <FullTillGrid
      :key="parentCategoryId"
      :parent-category-id="parentCategoryId"
    />
  </template>
  <template v-else>
    <FullTillList />
  </template>
</template>

<script setup lang="ts">
defineProps<{ parentCategoryId?: string }>()

const { gridModeEnabled } = useGridMode()
</script>
